import { LogLayer, LogLevel } from 'loglayer';

import { LogMeta, MessageDataType } from '../types';

export const logWithMetadata = (
	logInstance: LogLayer,
	level: LogLevel,
	message: MessageDataType,
	meta?: LogMeta,
) => {
	const target = meta ? logInstance.withMetadata(meta) : logInstance;

	target[level](message);
};
